// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"68a05c1d","796":"7d141f17"}[chunkId] + ".chunk.js";
};